<template>
  <b-row id="widthElement" class="mr-2">
    <b-col cols="12">
      <PageTitle title="Produtos selecionados" />
    </b-col>
    <b-col cols="12" class="mt-2">
      <div>
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
              url: 'https://www.youtube.com/watch?v=e2ic_8WH5VU&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=27', 
              title: 'Produtos selecionados' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/Produtos Selecionados (1).pdf"
        target="_blank"
        download
        ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
        >

        <a
          :href="'https://cms.construp.com.br/api/products/products-spreadsheet/'+`${userTypeId()}`"
          class="btn btn-success ml-3"
          target="_blank"
          download="produtos_selecionados.xlsx"
        >
          <i class="fas fa-poll-h"></i> 
          Baixar Planilha de Produtos
        </a>
      </div>
    </b-col>

    <b-col cols="12 mt-4">
      <h3 class="title font-weight-bold">Filtros</h3>
    </b-col>
    
    <span class="text-white" v-observe-visibility="menuPositionOne">.....</span>
    
    <b-col cols="12" class="mt-2 mb-2">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="startDate"
        :endDate.sync="endDate"
        :limparDados="limpar"
        @click.native="filterDate()"
      />
    </b-col>

    <b-col cols="12" class="mt-3">
      <button
      :class="
          typeProducts == 'geral'
          ? 'btn-type-products-selected'
          : 'btn-type-products'
      "
        @click="selectType('geral')"
      >
        Geral
      </button>
      <button
      :class="
          typeProducts == 'fixadores'
          ? 'btn-type-products-selected'
          : 'btn-type-products'
       "
        @click="selectType('fixadores')"
      >
        Fixadores
      </button>
    </b-col>
    <b-col cols="10" class="mt-3">
      <input
      @keyup.enter="get()"
      type="text"
      class="form-control"
      v-model="filters.name"
      placeholder="Nome do produto, código de barras, marca"
      />
    </b-col>

    <b-col cols="2" class="mt-3">
      <input
      @keyup.enter="get()"
      type="text"
      class="form-control"
      v-model="filters.cod_int"
      placeholder="Cód. int"
      />
    </b-col>

    <b-col cols="6" class="mt-3">
      <b-button variant="success" block @click="pesquisar()" :disabled="loading">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>

    <b-col cols="6" class="mt-3">

      <b-button variant="warning" block class="ml-2" @click="cleanSelection()">
        <i class="fas fa-trash mr-2"></i>
        Limpar todos os filtros
      </b-button>
    </b-col>

    <b-col cols="12" class="mt-5">
      <span class="lineDanger itensText" @click="produtosInativos()">Produtos inativos</span>
      
      <span class="lineEdit itensText" @click="editPromotion()">Editar aba promoção</span>

      <span 
        v-if="userTypeId() == 4402 || userTypeId() == 4477"
        class="lineSelected itensText mr-0" 
        v-b-tooltip.hover
        title="Iniciar sincronização estoque"
        @click="syncStock()"
      >
        Sincronizar estoque
      </span>

      <span 
        v-if="userTypeId() == 4402 || userTypeId() == 4477"
        class="lineSelected itensText"
        v-b-tooltip.hover
        title="Continuar sincronização estoque"
        @click="initSync()"
      >
        <i class="fas fa-sync"></i>
      </span>

      <span
        v-if="userTypeId() == 4402 || userTypeId() == 4477"
        class="lineEdit itensText mr-0"
        v-b-tooltip.hover
        title="Iniciar sincronizar preço"
        @click="syncPrice()"
      >
        Sincronizar preço
      </span>

      <span
        v-if="userTypeId() == 4402 || userTypeId() == 4477"
        class="lineEdit itensText"
        v-b-tooltip.hover
        title="Continuar sincronização preço"
        @click="initSyncPrice()"
      >
        <i class="fas fa-sync"></i>
      </span>
    </b-col>

    <b-col class="mt-4 mb-2">
      <h3 class="title font-weight-bold">
        Encontrado {{ pagination.total }} produto(s) selecionado(s) no total
      </h3>
      <span class="text-white" v-observe-visibility="menuPositionTwo">.</span>
    </b-col>

    <b-col cols="12" style="padding-bottom: 50px;">
      <b-table
        striped
        bordered
        hover
        thead-class
        show-empty
        responsive
        fixed
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :tbody-tr-class="validItens"
        :thead-tr-class="'position: sticky'"
      >
        <template #head()="data">
          <thead class="p-0 m-0">
            <tr class="p-0 m-0">
              <th :class="!menuVisibleOne && !menuVisibleTwo ?  'headTableFixed': 'headTable'">
                {{ data.label }}
              </th>
            </tr>
          </thead>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(priceSalesFormat1)="data">
          <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
          <span
            v-if="data.item.priceRule.length > 0"
            class="btn btn-dark btn-sm cursor-pointer ml-1"
            v-b-tooltip.hover
            :title="formattedPriceRules(data.item.priceRule)"
          >
            <i class="fas fa-info-circle"></i>
          </span>
        </template>

        <template #cell(photo)="data">
          <span
            @click="
              data.item.photo && showModal(data.item.productId, data.item.product, typeProducts, data.item.selectedAt)
            "
          >
            <img
              :src="data.item.photo ? linkFotos(data.item.origem) + data.item.photo : require('@/assets/img/product-placeholder.jpg')"
              :alt="data.item.product"
              class="imgWidth"
            />
          </span>
        </template>

        <template #cell(product)="data">
          <span class="spanProduct">
            {{ data.item.product }}
          </span>
        </template>

        <template #cell(codbar)="data">
          <b-badge>
            {{  data.item.codbar }}
          </b-badge>
        </template>

        <template #cell(quantityStock)="data">
          <div v-if="data.item.statusSelected && data.item.statusSelected != null">
            {{ data.item.manage_stock == true ? data.item.quantity_stock : 'Não' }}
          </div>

          <span>
            {{ data.item.quantityValid == true ? data.item.quantityStock : '-' }}
          </span>
        </template>

        <template #cell(codInternoAdd)="data">
          <span>{{ data.item.codInterno ? data.item.codInterno : '-' }}</span>
        </template>

        <template #cell(discont)="data">
          <span
            :class="data.item.discont ? 'dicontTable' : ''"
          >
            {{ data.item.discont && data.item.discontType == 'percentage' ? data.item.discont+'%' : '' }}
            {{ 
              data.item.discontType == 'money' ? 
              formatMoneyUn(data.item.discontMoney) : 
              '' 
            }}
          </span>
        </template>

        <template #cell(actions)="data">
          <b-col v-if="whatClerkPermission()">
            <b-row no-gutters>
              <b-col cols="12" md="12" class="mb-2" v-if="!data.item.editing">
                <b-button
                  variant="dark"
                  size="sm"
                  title="Mostrar ações"
                  v-b-tooltip.hover
                  @click="mostrarAcoes(data.index, true)"
                >
                  <i class="fas fa-arrow-down"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="primary"
                  size="sm"
                  title="Editar preço, qtd, estoque..."
                  v-b-tooltip.hover
                  @click="editProduct(data.item.id)"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="primary"
                  size="sm"
                  title="Editar informações do produto"
                  v-b-tooltip.hover
                  @click="editarProduto(data.item.productId)"
                >
                  <i class="fas fa-pen"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="primary"
                  size="sm"
                  title="Preços customizados"
                  v-b-tooltip.hover
                  @click="
                    openSelectedProductPricesEdit({
                      selectedProductId: data.item.id,
                      productName: data.item.product,
                      productId: data.item.productId,
                    })
                  "
                >
                  <i class="fas fa-funnel-dollar"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="dark"
                  size="sm"
                  title="Categoria do produto"
                  v-b-tooltip.hover
                  @click="transferProductCategory(data.item)"
                >
                  <i class="fas fa-th-large"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="dark"
                  size="sm"
                  title="Categoria home"
                  v-b-tooltip.hover
                  @click="openModalCategory(data.item.productId)"
                >
                  <i class="fas fa-align-justify"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  v-if="data.item.status == 1"
                  variant="dark"
                  size="sm"
                  title="Tag de pesquisa"
                  v-b-tooltip.hover
                  @click="openModalTag(data.item.id)"
                >
                  <i class="fas fa-tags"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  v-if="data.item.status == 1"
                  variant="success"
                  size="sm"
                  title="Gerar QRcode"
                  v-b-tooltip.hover
                  @click="openModalQrcode(data.item.productId)"
                >
                  <i class="fas fa-qrcode"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="outline-success"
                  size="sm"
                  title="Relacionar Produtos"
                  v-b-tooltip.hover
                   @click="$refs.modalRelationProduct.toggleOpen(
                    { 
                      idSelectedProduct: data.item.id, 
                      title: data.item.product 
                    }
                  )"
                >
                  <i class="fas fa-plus"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="danger"
                  size="sm"
                  title="Excluir produto"
                  v-b-tooltip.hover
                  @click="trashSelectedProduct(data.item.productId)"
                >
                  <i class="fas fa-trash"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  v-if="data.item.status == 1"
                  variant="warning"
                  size="sm"
                  title="Inativar produto"
                  v-b-tooltip.hover
                  @click="InativeProduct(data.item.productId)"
                >
                  <i class="fas fa-ban"></i>
                </b-button>
                <b-button
                  v-else
                  variant="success"
                  size="sm"
                  title="Ativar produto"
                  v-b-tooltip.hover
                  @click="ativarProduto(data.item.productId)"
                >
                  <i class="fas fa-eye"></i>
                </b-button>
              </b-col>
              
              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="primary"
                  size="sm"
                  title="Editar desconto do produto"
                  v-b-tooltip.hover
                  @click="editDiscountProduct(data.item.id)"
                >
                  <i class="fas fa-percentage"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  :variant="data.item.promotion ? 'success' : 'danger'"
                  size="sm"
                  :title="data.item.promotion ? 'Item está ativo na aba promoção' : 'Item não está ativo na aba promoção'"
                  v-b-tooltip.hover
                  @click="saveProductMenuPromotion(data.item.id)"
                >
                  <i :class="data.item.promotion ? 'fas fa-check' : 'fas fa-times'"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="4" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="success"
                  size="sm"
                  title="Grade de Produto"
                  v-b-tooltip.hover
                   @click="$refs.modalProductVariation.toggleOpen(
                    { 
                      idSelectedProduct: data.item.productId, 
                      title: data.item.product 
                    }
                  )"
                >
                  <i class="fas fa-th-large"></i>
                </b-button>
              </b-col>

              <b-col cols="12" md="12" class="mb-2" v-if="data.item.editing">
                <b-button
                  variant="dark"
                  size="sm"
                  title="Ocultar ações"
                  v-b-tooltip.hover
                  @click="mostrarAcoes(data.index, false)"
                >
                  <i class="fas fa-arrow-up"></i>
                </b-button>
              </b-col>

            </b-row>
          </b-col>
        </template>
      </b-table>
    </b-col>

    <div v-observe-visibility="visibilityChanged">
      <span class="ml-4">Carregando...</span>
    </div>

    <br><br><br>

    <b-modal
      title="Transferir produto de categoria"
      size="lg"
      id="modal-transfer-product-category"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="12" class="mt-2">
          <label>Para:</label>
          <input type="text" class="form-control" v-model="syncCategoria" disabled>
        </b-col>

        <b-col cols="12" class="mb-2 mt-2">
          <label>Categoria: <span class="text-danger d-inline">*</span></label>
          <span class="ml-2"><b>{{syncCategoria}}</b></span>
          <span class="btn btn-primary float-right mb-1" @click="syncLimparCategoria()">Limpar</span>

          <select class="custom-select mb-3" @change="syncSelectId()" v-model="syncCategoriaSelect">
              <option selected value="">-- Selecione a categoria {{syncCount+1}} --</option>
              <option v-for="(item, i) in syncCategorias" :key="i" :value="item">{{item.nome_departamento}}</option>
          </select>
        </b-col>

        <b-col cols="12" class="mt-2">
          <button class="btn btn-success btn-block" :disabled="syncSetLink == false" @click="updateProductsCategory()">
            Atualizar categoria do produto
          </button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Produto categoria"
      size="lg"
      id="selectCategory"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="6" class="mb-2">
          <label>Categoria em qual o produto vai aparecer</label><br />

          <select
            class="form-select mb-2"
            v-model="idCategory"
            style="width: 100%"
          >
            <option selected>-- Selecione --</option>
            <option v-for="(item, i) in items" :key="i" :value="item.id">
              {{ item.name }} ({{ item.status == 0 ? 'Ativo' : 'Inativo' }})
            </option>
          </select>

          <br />
          <button
            class="btn btn-success btn-block"
            @click="newCategoryProduct()"
          >
            <i class="fas fa-save mr-2"></i>
            Cadastrar
          </button>
        </b-col>

        <b-col cols="6" class="mb-2">
          <label>Esse produto já está nessas categoria(s)</label><br />

          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Categoria</th>
                <th style="width: 70px">Funções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in categoryProductItems" :key="i">
                <th>{{ item.name }}</th>
                <td>
                  <span class="danger" @click="deleteMenu(item.id)">
                    Remover
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Gerar QR Code"
      size="lg"
      id="qrModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <h1 class="font-weight-bold text-uppercase">Gerar QR Code para Produto</h1>
      <div class="input-group mb-3">
        <input type="text" v-model="url" class="form-control" disabled aria-describedby="enviteQrCode">

        <div class="input-group-append">
          <span class="btn btn-outline-success" id="enviteQrCode" @click="downloadQrCode('qrCodeCanvasProduct', 'qrcode_product.png')">
            <i class="fas fa-download mr-2"></i>
            Baixar qr code
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <qrcode-vue
          class="mt-2"
          :value="url"
          size=120
          level="H"
          id="qrCodeCanvasProduct"
        />
      </div>
    </b-modal>

    <SetSelectedProductPrice ref="setSelectedProductPrice" @saved="() => {}" />

    <b-modal
      ref="detalhesProduto"
      size="xl"
      centered
      hide-footer
      :title="productModal"
      header-bg-variant="orange"
      header-text-variant="light"
    >
      <b-row>
        <b-col cols="5" class="slideImg">
          <b-carousel
            style="text-shadow: 0px 0px 2px #000"
            indicators
            img-width="600"
            img-height="600"
            controls
            sliding-start
            sliding-end
            v-if="detalhesP.fotos.length > 0"
          >
            <b-carousel-slide
              v-for="(item, i) in detalhesP.fotos"
              :key="i"
              :img-src="linkFotos(detalhesP.produto.origem) + item.foto_png"
            ></b-carousel-slide>
          </b-carousel>

          <div v-else>
            <h1>Sem imagens</h1>
          </div>
        </b-col>

        <b-col cols="7">
          <div
            class="accordion"
            role="tablist"
            v-if="detalhesP.produto != null"
          >

            <b-card-header class="text-center">
                <h4>{{ detalhesP.produto.departamentos }}</h4>
            </b-card-header>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="success"
                  >Detalhes</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <label>Produto:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.produto"
                        class="form-control"
                        readonly
                      />
                      <div v-if="productSelectedAt" class="fs-14 text-secondary">
                        (Selecionado em {{ productSelectedAt }})
                      </div>
                    </b-col>

                    <b-col cols="4" class="mb-2">
                      <label>Marca:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.marca"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="4" class="mb-2">
                      <label>Cod. barras:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.codbar"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="4" class="mb-2">
                      <label>{{
                        typeProducts == 'fixadores'
                          ? 'Un. estoque'
                          : 'Dimensões:'
                      }}</label>
                      <input
                        type="text"
                        :value="
                          typeProducts == 'fixadores'
                            ? detalhesP.produto.unidade
                            : detalhesP.produto.dimensoes
                        "
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="12" class="mb-2">
                      <label>Descrição:</label>
                      <textarea
                        type="text"
                        :value="detalhesP.produto.descricao"
                        class="form-control"
                        rows="3"
                        readonly
                      ></textarea>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" v-if="detalhesP.fichas.length > 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="info"
                  >Ficha técnica</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body class="scrollDiv">
                  <b-row v-for="(item, i) in detalhesP.fichas" :key="i">
                    <b-col cols="4" class="mb-2">
                      <input
                        type="text"
                        :value="item.tipo"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="8" class="mb-2">
                      <input
                        type="text"
                        :value="item.descricao"
                        class="form-control"
                        readonly
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Foto do produto"
      size="xl"
      id="modalImagem"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="12">
          <img :src="urlImagem" style="width: 100%;">
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Detalhes do produto"
      size="xl"
      id="modalProduto"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row>
        <b-col cols="9" class="mb-2">
          <label>Nome do produto <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.produto" placeholder="Nome do produto">
          <span class="text-danger d-inline" v-if="error.produto">Informe o nome do produto</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Código de barra <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.codbar" disabled placeholder="Código de barras">
          <span class="text-danger d-inline" v-if="error.codbar">Informe o Cód. barras</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Marca <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.marca" placeholder="Marca do produto">
          <span class="text-danger d-inline" v-if="error.marca">Informe a marca</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Unidade de medida <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.unidade" placeholder="Un, Kg, Cm...">
          <span class="text-danger d-inline" v-if="error.unidade">Informe a Unidade de medida</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Peso (Kg)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.peso" placeholder="Peso do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.peso">Informe o peso do produto</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Altura (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.altura" placeholder="Altura do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.altura">Informe a altura</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Largura (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.largura" placeholder="Largura do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.largura">Informe a largura</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Comprimento (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.comprimento" placeholder="Comprimento do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.comprimento">Informe o comprimento</span>
        </b-col>

        <b-col cols="3" class="mb-4">
          <label>Qtd Metro² Caixa<span class="text-danger d-inline ml-2">(Pisos e revestimento)</span></label>
          <input 
            type="text" 
            class="form-control" 
            v-model="dataProduct.qtd_metros" 
            placeholder="m² caixa piso" 
            v-mask="['#.##','#.###', '##.###']"
          >
        </b-col>

        <b-col cols="12" class="mb-2">
          <label>Descrição do produto (Opcional)</label>
          <textarea class="form-control" rows="3" placeholder="Descrição do produto" v-model="dataProduct.descricao"></textarea>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Ficha(s) tec. (Opcional)</label>
          <span class="btn btn-primary float-right" @click="openModalFicha()">+</span>

          <table class="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Descrição</th>
                <th scope="col" class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in dataProduct.produto_fichas" :key="i" v-show="item.tipo != null">
                <td>
                  <input type="text" class="form-control" v-model="dataProduct.produto_fichas[i].tipo">
                </td>
                <td>
                  <input type="text" class="form-control" v-model="dataProduct.produto_fichas[i].descricao">
                </td>
                <td class="text-center">
                  <span class="cursor-pointer" style="color:red" @click="removerFicha(i, item)">
                    <i class="fas fa-trash"></i>
                  </span>
                </td>
              </tr>
              <tr v-if="dataProduct.produto_fichas && dataProduct.produto_fichas.length == 0">
                <td colspan="3">
                  <span>Sem ficha tec. cadastrada!</span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Imagem do produto:</label>
          <input type="file" id="file" ref="file" accept="image/*" @change="uploadImage()" class="form-control" v-if="dataProduct.origem != 'Belenus'">          
          <span class="text-danger d-inline" v-if="error.fotos">Informe a(s) foto(s)</span>

          <b-row>
            <b-col cols="2" class="mt-2 mr-2 text-center" v-for="(item, i) in dataProduct.produto_fotos" :key="i">
              <span class="cursor-pointer" style="color:red" @click="removerFoto(i, item)" v-if="dataProduct.origem != 'Belenus'">
                <i class="fas fa-times-circle"></i>
              </span>
              <img 
                :src="formatUrl(item.foto_png ? item.foto_png : item)"
                :alt="dataProduct.produto+' - '+i"
                @click="openImg(formatUrl(item.foto_png ? item.foto_png : item))"
                width="70" 
                class="cursor-pointer"
              >
            </b-col>

            <b-col cols="12" class="mt-2">
              <label>Video do produto: (Opcional)</label>
              <input 
                type="url" 
                v-model="dataProduct.path_video"  
                placeholder="Carregar url do vídeo" 
                class="form-control mb-1"
              >
              
              <div v-for="(item, i) in dataProduct.midiaProduct" :key="i">
                <span
                  v-if="item.type == 1"
                  @click="removeVideo(item)"
                  class="cursor-pointer"
                  style="color:red"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <iframe
                  v-if="item.type == 1"
                  width="100%"
                  height="200px"
                  :src="`https://www.youtube.com/embed/${getYoutubeVideoUri(item.path)}`"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </b-col>

            <b-col cols="12" class="mt-2">
                <label>PDF do produto: (Opcional)</label>
                <b-form-file
                  placeholder="Adicionar arquivo pdf"
                  @change="uploadPdf()"
                  type="application/pdf"
                  ref="pdf"
                  id="pdf"
                  class="form-control"
                >
                </b-form-file>
              <span v-for="(item, i) in dataProduct.midiaProduct" :key="i">
                <span
                  v-if="item.type == 2"
                  @click="removePdf(item)"
                  class="cursor-pointer mt-3"
                  style="color:red"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <i v-if="item.type == 2" class="far fa-file-pdf fa-lg mr-4 mt-3"></i>
              </span>
            </b-col>
          </b-row>
        </b-col>

        <b-modal
          title="Nova ficha tec."
          size="md"
          id="modalFicha"
          header-bg-variant="orange"
          header-text-variant="light"
          centered
          hide-footer>
          <b-row>
            <b-col cols="6" class="mb-2">
              <label>Tipo:</label>
              <input type="text" class="form-control" v-model="tipo" placeholder="Ex: Cor:">
            </b-col>

            <b-col cols="6" class="mb-2">
              <label>Descrição:</label>
              <input type="text" class="form-control" v-model="descricao" placeholder="Ex: Azul">
            </b-col>

            <b-col cols="12" class="mt-2 text-center">
              <button class="btn btn-success" @click="addFicha()">Salvar ficha tec.</button>
            </b-col>
          </b-row>
        </b-modal>

        <b-col cols="12" class="text-center mt-4 mb-2">
          <button class="btn btn-success mr-2" @click="alterarProduto()">Alterar produto</button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Tags do produto"
      size="lg"
      id="showModalTag"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row>
        <b-col cols="12">
          <div class="alert alert-primary" role="alert">
            Separe as tags de pesquisa por <b>","</b> para inserir varias tags!
          </div>
        </b-col>

        <b-col cols="12">
          <label>Tags:</label>
          <input type="text" class="form-control" v-model="tag.tags" placeholder="Ex: Cimento, Rebocar, Piso">
        </b-col>

        <b-col cols="12" class="text-center mt-4">
          <button class="btn btn-success" @click="saveTags()">Salvar tags</button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Regra de preço por quantidade"
      size="lg"
      id="modalPriceRule"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row v-if="modalEditProductId != null">
        <b-col cols="12" class="text-right mb-2">
          <button class="btn btn-primary" @click="newRulePrice()">
            Adicionar nova regra
          </button>
        </b-col>

          <b-col
            cols="12"
            v-for="(item, i) in fields.selectedProducts[`${modalEditProductId}`].priceRule" :key="i"
          >
            <b-row>
              <b-col cols="3" class="mb-2">
                <label>Acima de xx unidades:</label>
                <input type="number" class="form-control" v-model="item.quantity" placeholder="XX">
              </b-col>
              <b-col cols="5" class="mb-2">
                <label>Preço por unidade:</label>
                <input type="text" class="form-control" v-model="item.price" placeholder="R$ 0,00" v-money="formatTipo">
              </b-col>
              <b-col cols="2" class="mb-2">
                <label>Qtd. exata:</label>
                <span
                  v-b-tooltip.hover
                  title="O desconto se aplica apenas se a quantidade for igual à especificada."
                  class="ml-1"
                >
                  <i class="fas fa-info-circle"></i>
                </span>
                <input type="checkbox" class="form-control" v-model="item.exact_amount">
              </b-col>
              <b-col cols="2" class="mb-2 d-flex align-items-end">
                <button class="btn btn-danger" @click="dellPriceRule(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </b-col>
            </b-row>
            <hr>
          </b-col>

        <b-col cols="12" class="text-center mt-4">
          <button class="btn btn-success" @click="$bvModal.hide('modalPriceRule')">Salvar regra(s)</button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Editar produto"
      size="lg"
      id="modalEditProduct"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row v-if="modalEditProductId != null">
        <b-col cols="8" class="mb-2">
          <b-row>
            <b-col cols="6">
              <label>Preço:</label>
            </b-col>
            <b-col cols="6" class="text-right mb-1">
              <button
                class="btn btn-success"
                v-b-tooltip.hover
                title="Add regra de preço"
                @click="addRegraPreco()"
              >
                +
              </button>
            </b-col>
          </b-row>
          <InputMoney v-model="fields.selectedProducts[`${modalEditProductId}`].priceSalesFormat1" />
        </b-col>

        <b-col cols="4" class="mb-2">
          <label class="mb-3">Cód. interno:</label>
          <input
            class="form-control"
            type="text"
            v-model="fields.selectedProducts[`${modalEditProductId}`].codInterno"
            @blur="validCodInterno(`${modalEditProductId}`)"
            @focus="setdCodInterno(`${modalEditProductId}`)"
          />
        </b-col>

        <b-col cols="12" v-if="fields.selectedProducts[`${modalEditProductId}`].priceRule.length > 0">
          <b-alert variant="primary" show>
            <span v-for="(item, i) in fields.selectedProducts[`${modalEditProductId}`].priceRule" :key="i">
              {{i == 0 ? '' : '-'}} {{item.quantity}}/{{item.price}}
            </span>
          </b-alert>
        </b-col>

        <b-col cols="6" class="mb-2">
          <label>Estoque:</label>
          <b-form-checkbox
            v-model="fields.selectedProducts[`${modalEditProductId}`].quantityValid"
            switch
          >
            {{ fields.selectedProducts[`${modalEditProductId}`].quantityValid ? ' Sim' : ' Não' }}
          </b-form-checkbox>
          <input
            class="form-control"
            :style="fields.selectedProducts[`${modalEditProductId}`].quantityValid == true ? 'display:block' : 'display:none'"
            type="number"
            :placeholder="0"
            v-model.number="fields.selectedProducts[`${modalEditProductId}`].quantityStock"
          >
        </b-col>

        <b-col cols="6" class="mb-2">
          <label>Desconto:</label><br>

          <span>Porcentagem</span>
          <input 
            type="radio" 
            name="desconto" 
            value="percentage" 
            class="ml-1 mr-3" 
            v-model="fields.selectedProducts[`${modalEditProductId}`].discontType"
          >
          <span>Reais</span>
          <input 
            type="radio" 
            name="desconto" 
            value="money" 
            class="ml-1" 
            v-model="fields.selectedProducts[`${modalEditProductId}`].discontType"
          >

          <input
            v-if="fields.selectedProducts[`${modalEditProductId}`].discontType == 'percentage'"
            class="form-control"
            type="text"
            v-model="fields.selectedProducts[`${modalEditProductId}`].discont"
            v-mask="['#', '##']"
          />
          <InputMoney  
            v-if="fields.selectedProducts[`${modalEditProductId}`].discontType == 'money'" 
            v-model="fields.selectedProducts[`${modalEditProductId}`].discontMoney" />
        </b-col>

        <b-col cols="6" class="mb-2">
          <label>Início do desconto:</label>
          <input
            class="form-control"
            type="datetime-local"
            :max="fields.selectedProducts[`${modalEditProductId}`].discontEnd"
            v-model="fields.selectedProducts[`${modalEditProductId}`].discontStart"
          />
        </b-col>

        <b-col cols="6" class="mb-2">
          <label>Fim do desconto:</label>
          <input
            class="form-control"
            type="datetime-local"
            :min="fields.selectedProducts[`${modalEditProductId}`].discontStart"
            v-model="fields.selectedProducts[`${modalEditProductId}`].discontEnd"
          />
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Entrega em 24hrs:</label>
          <b-form-checkbox
            v-model="fields.selectedProducts[`${modalEditProductId}`].withdrawalInOneDay"
            switch
          >
            {{ fields.selectedProducts[`${modalEditProductId}`].withdrawalInOneDay ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Entrega com motoboy:</label>
          <b-form-checkbox
            v-model="fields.selectedProducts[`${modalEditProductId}`].motorcycle"
            switch
          >
            {{ fields.selectedProducts[`${modalEditProductId}`].motorcycle ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </b-col>

        
        <b-col cols="2" class="mb-2">
          <label>Preço Exclusivo:</label>
          <b-form-checkbox
            v-model="fields.selectedProducts[`${modalEditProductId}`].isExclusivePrice"
            switch
          >
            {{ fields.selectedProducts[`${modalEditProductId}`].is_exclusive_price ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </b-col>

         <b-col cols="4" class="mb-2">
          <label>É fixador (mostra paquímetro):</label>
          <b-form-checkbox
            v-model="fields.selectedProducts[`${modalEditProductId}`].isCaliper"
            switch
          >
            {{ fields.selectedProducts[`${modalEditProductId}`].is_caliper ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" class="mb-2">
          <label>Tipo de entrega:</label><br>
          <input type="radio" name="typeDelivery" value="1" v-model="fields.selectedProducts[`${modalEditProductId}`].typeDelivery">
          <label class="ml-1 mr-3">Só entrega</label>
          <input type="radio" name="typeDelivery" value="2" v-model="fields.selectedProducts[`${modalEditProductId}`].typeDelivery">
          <label class="ml-1 mr-3">Só retira</label>
          <input type="radio" name="typeDelivery" value="null" v-model="fields.selectedProducts[`${modalEditProductId}`].typeDelivery">
          <label class="ml-1">Todos</label>
        </b-col>

        <b-col cols="12" class="mt-2 text-center">
          <button 
            class="btn btn-success btn-block"
            @click="editSelectedProduct(fields.selectedProducts[`${modalEditProductId}`])"
          >
            Atualizar produto
          </button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Regra de desconto"
      size="lg"
      id="modalDiscontRule"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row v-if="modalPriceDiscountId != null">
        <b-col cols="12" class="text-right mb-2">
          <button class="btn btn-primary" @click="newRulePriceDiscount()">
            Adicionar nova regra
          </button>
        </b-col>

        <b-col
          cols="12"
          v-for="(item, i) in fields.selectedProducts[`${modalPriceDiscountId}`].priceDiscountRules" :key="i"
        >
          <b-row>
            <b-col cols="3" class="mb-2">
              <label>Acima de xx unidades:</label>
              <input type="number" class="form-control" v-model="item.qtd" placeholder="XX">
            </b-col>

            <b-col cols="6" class="mb-2">
              <label>Desconto:</label><br>
              <input
                v-if="item.type == '1'"
                class="form-control"
                type="text"
                v-model="item.discount"
                v-mask="['#', '##']"
              />
              <InputMoney v-if="item.type == '2'" v-model="item.discount" />
              <span>Porcentagem</span>
              <input 
                type="radio" 
                :name="'desconto'+i" 
                value="1" 
                class="ml-1 mr-3" 
                v-model="item.type"
              >
              <span>Reais</span>
              <input 
                type="radio" 
                :name="'desconto'+i" 
                value="2" 
                class="ml-1" 
                v-model="item.type"
              >
            </b-col>

            <b-col cols="3" class="mb-2 mt-2 d-flex align-items-center">
              <button class="btn btn-danger btn-block" @click="dellPriceDiscountRule(i)">
                <i class="fas fa-trash"></i>
              </button>
            </b-col>
          </b-row>
          <hr>
        </b-col>

        <b-col cols="12" class="text-center mt-4">
          <button 
            class="btn btn-success"
            @click="savePriceDiscountRule(fields.selectedProducts[`${modalPriceDiscountId}`])"
          >
            Salvar regra(s)
          </button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Editar aba de promoção"
      size="lg"
      id="modalEditPromotion"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row>
        <b-col cols="4">
          <label>Titulo:</label>
          <input type="text" class="form-control" v-model="promotion.title">
        </b-col>

        <b-col cols="8">
          <label>Descrição:</label>
          <input type="text" class="form-control" v-model="promotion.description">
        </b-col>

        <b-col cols="12" class="mt-2">
          <label>Status:</label><br>
          <span>Ativo</span>
          <input 
            type="radio" 
            name="desconto" 
            :value="true" 
            class="ml-1 mr-3" 
            v-model="promotion.status"
          >
          <span>Inativo</span>
          <input 
            type="radio" 
            name="desconto" 
            :value="false" 
            class="ml-1" 
            v-model="promotion.status"
          >
        </b-col>

        <b-col cols="12" class="text-center mt-4">
          <button class="btn btn-success" @click="saveMenuPromotion()">Salvar</button>
        </b-col>
      </b-row>
    </b-modal>

    <VideoManual ref="videoManual"/>
    <SelectedProductsModal
      ref="selectedProductsModal"
      @saveProduct="editProductModal($event)"
      @validCodeModal="validCode($event)" 
      @setCodeInternoModal="setdCodInterno($event)"
    />

    <ModalRelationProduct
      ref="modalRelationProduct"
    />

    <ModalProductVariation
      ref="modalProductVariation"
    />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import ProductsFilters from './ProductsFilters.vue';
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import InputMoney from '../../../components/Inputs/InputMoney.vue';
import PeriodsFilters from '../../../components/Inputs/PeriodsFilters.vue';
import VideoManual from '@/components/VideoManual.vue';
import SelectedProductsModal from '@/components/SelectedProductsModal.vue';
import { convertBrlToDecimal } from '@/utils';
import QrcodeVue from 'qrcode.vue';
import { getYoutubeVideoUri } from 'Utils/index.js';
import SetSelectedProductPrice from './SetSelectedProductPrice.vue';
import ModalRelationProduct from './ModalRelationProduct.vue';
import ModalProductVariation from './ModalProductVariation.vue';

export default {
  name: 'SelectProducts',
  mixins: [makeToast],
  components: {
    ProductsFilters,
    PageTitle,
    InputMoney,
    SetSelectedProductPrice,
    PeriodsFilters,
    VideoManual,
    SelectedProductsModal,
    QrcodeVue,
    ModalRelationProduct,
    ModalProductVariation
  },
  data() {
    return {
      url: '',
      // valuePercent: '',
      menuVisibleOne: false,
      menuVisibleTwo: false,
      typeProducts: 'geral',
      setCodInternoId: null,
      modalEditProductId: null,
      modalPriceDiscountId: null,
      items: null,
      idCategory: null,
      categoryProductId: null,
      categoryProductItems: null,
      filters: {},
      priceRule: [],
      startDate: '',
      buscaInativo: '',
      endDate: '',
      loading: false,
      productModal: '',
      productSelectedAt: '',
      limpar: false,
      quantityStock: 0,
      path: '',
      promotion: {
        status: false,
        title: '',
        description: '',
        construp_user_id: null
      },
      tag: {
        id: null,
        tags: '',
        selected_product_id: null
      },
      slideOpts: {
        initialSlide: 0,
        speed: 400,
      },
      detalhesP: {
        fotos: [],
        fichas: [],
        produto: null,
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
        lastPage: 1
      },
      fields: {
        selectedProducts: {},
      },
      urlImagem: '',
      tipo: '',
      descricao: '',
      dataProduct: {
        produto: null,
        id: null,
        path_video: null,
        path_pdf: null,
        type: null,
        midiaProduct: [],
        codbar: null,
        descricao: '',
        marca: null,
        unidade: null,
        peso: null,
        altura: null,
        largura: null,
        comprimento: null,
        departamento_id: null,
        lojista_id: null,
        aprovar: false,
        discontType: null,
        discontMoney: null,
        discontStart: null,
        discontEnd: null,
        qtd_metros: null,
        priceRule: [],
        priceDiscountRules: [],
        produto_fichas: [],
        produto_fichas_remover: [],
        produto_fotos_remover: [],
        produto_fotos: [], 
        origem: null,
        cad_status: null
      },
      error: {
        produto: false,
        codbar: false,
        marca: false,
        unidade: false,
        peso: false,
        altura: false,
        largura: false,
        comprimento: false,
        departamento_id: false,
        fichas: false,
        fotos: false
      },
      formatTipo: {
        decimal: '.',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true
      },
      syncSetLink: false,
      syncCount: 0,
      syncCategoriaSelect: '',
      syncCategoria: '',
      syncCategorias: [],
      inative: false,
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'productId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Detalhes',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 80px;',
            tdStyle: 'width: 80px;',
          },
          {
            key: 'product',
            label: 'Produto'
          },
          {
            key: 'marca',
            label: 'Marca',
            thStyle: 'width: 130px;'
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            thStyle: 'width: 130px'
          },
          {
            key: 'priceSalesFormat1',
            label: 'Preço',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 150px'
          },
          {
            key: 'quantityStock',
            label: 'Estoque',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 80px'
          },
          {
            key: 'codInternoAdd',
            label: 'C. interno',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 100px'
          },
          {
            key: 'discont',
            label: 'Desconto',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: 'width: 80px'
          },
          {
            key: 'actions',
            label: 'Ações',
            thClass: 'text-center',
            tdClass: 'text-center',
            headerClass: "text-center",
            thStyle: 'width: 170px;',
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  mounted() {
    this.get();
    this.getMenuPromotion();
    // this.getPercent();
    this.getCategory();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getSelectedProducts',
      'inativeSelectedProduct',
      'updateSelectedProduct',
      'trashSelectedProductId',
      'getMenusApp',
      'getMenuProductsApp',
      'newMenuProductsCategory',
      'deleMenuCategoryProduct',
      'getDetalhesProdutoGeral',
      'getDetalhesProdutoFixadores',
      'ativarProdutoLojista',
      'validarCodInternoLojista',
      'searchUrl'
    ]),

    removeVideo(item) {
      this.$store.dispatch('startLoader');
      if (item == null) {
        this.makeToast('Sucesso!', "", 'warning');
      }
      this.$store.dispatch('files/deleteVideoProduct', item.id)
      .then((resp) => {
        this.makeToast('Sucesso!', resp.data[0], 'success');
        this.dataProduct.midiaProduct = this.dataProduct.midiaProduct.filter((video) => video.id !== item.id);
        this.dataProduct.path_video = null;
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível deletar o vídeo, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },

    removePdf(item) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/deletePdfFileProduct', item.path)
      .then((resp) => {
        this.makeToast('Sucesso!', resp.data[0], 'success');
        this.dataProduct.midiaProduct = this.dataProduct.midiaProduct.filter((pdf) => pdf.id !== item.id);
        this.dataProduct.path_pdf = null;
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível deletar PDF, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },

    formattedPriceRules(itens) {
      return itens.map(item => `${item.quantity}/${item.price}`).join(' - ');
    },
    transferProductCategory(item) {
      this.editarCategoria = item;

      this.getCategoria(0, true);
    },
    syncSelectId() {
      const item = this.syncCategoriaSelect;

      if(item && item.nome_departamento) {
        if(this.syncSetLink == false) {
          const seta = this.syncCount == 0 ? '' : ' -> ';            
          this.syncCategoria = this.syncCategoria+seta+item.nome_departamento;
        } else {
          const partes = this.syncCategoria.split(' -> ');

          partes.pop();
          partes.push(item.nome_departamento);
          
          this.syncCategoria = partes.join(' -> ');
        }
      }

      if(item.link == true) {
        this.syncSetLink = true;
      } else {
        
        if(item && item.nome_departamento) {

          this.syncCount = this.syncCount +1;
          this.syncCategoriaSelect = '';

          this.getCategoria(item.id);

          this.syncSetLink = false;
        }
      }
    },
    syncLimparCategoria() {
      this.syncSetLink = false;
      this.syncCount = 0;
      this.syncCategoriaSelect = '';
      this.syncCategoria = '';

      this.getCategoria(0);
    },
    getCategoria(id, isModal = false) {
      const data = {
        categoriaId: id,
        lojistaId: this.dadosUsuario.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCategoriasId', data)
        .then((response) => {
          this.syncCategorias = response.data;

          if(isModal) {
            this.$bvModal.show('modal-transfer-product-category');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    updateProductsCategory() {
      const data = {
        newCategory: this.syncCategoriaSelect.id,
        productId: this.editarCategoria.productId,
        lojistaId: this.dadosUsuario.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/updateProductIdCategory', data)
        .then((response) => {
          if(response.data.type == 'success') {
            this.$bvModal.hide('modal-transfer-product-category');
            this.syncLimparCategoria();
            
            this.table.records = [];
            this.get();
          }

          this.makeToast(response.data.title, response.data.text, response.data.type);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    syncStock() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/syncStockApi', this.userTypeId())
      .then((response) => {
        if(response.data.sync && response.data.sync == true) {
          this.initSync();
        } else {
          this.$store.dispatch('endLoader');
        }
      }).catch(() => {
        this.makeToast('Oopss', 'Não foi possível iniciar a sincronização!', 'danger')
        this.$store.dispatch('endLoader');
      });
    },
    syncPrice() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/syncStockApi', this.userTypeId())
      .then((response) => {
        if(response.data.sync && response.data.sync == true) {
          this.initSyncPrice();
        } else {
          this.$store.dispatch('endLoader');
          this.makeToast('Sucesso', 'Sincronização finalizada!', 'success')
        }
      }).catch(() => {
        this.makeToast('Oopss', 'Não foi possível iniciar a sincronização!', 'danger')
        this.$store.dispatch('endLoader');
      });
    },
    initSyncPrice() {
      let path = 'shopkeeper/initSyncPriceApi';
      if (this.userTypeId() == 4477) {
        path = 'shopkeeper/carflaxInitSyncPriceApi';
      }

      this.$store.dispatch(path)
      .then((response) => {
        if(response.data.sync && response.data.sync == true) {
          this.initSyncPrice();
        } else {
          this.$store.dispatch('endLoader');
        }
      }).catch(() => {
        this.makeToast('Oopss', 'Não foi possível finalizar a sincronização!', 'danger')
        this.$store.dispatch('endLoader');
      });
    },
    initSync() {
      let path = 'shopkeeper/initSyncApi';
      if (this.userTypeId() == 4477) {
        path = 'shopkeeper/carflaxInitSyncApi';
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch(path, this.userTypeId())
      .then((response) => {
        if(response.data.sync && response.data.sync == true) {
          this.initSync();
        } else {
          this.$store.dispatch('endLoader');
          this.makeToast('Sucesso', 'Sincronização finalizada!', 'success')
        }
      }).catch(() => {
        this.makeToast('Oopss', 'Não foi possível finalizar a sincronização!', 'danger')
        this.$store.dispatch('endLoader');
      });
    },
    openModalTag(id) {
      this.limparTags();
      
      this.tag.selected_product_id = id;

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getPaymentTags', id)
      .then((response) => {
        if(response.data.id) {
          this.tag = response.data;
        }
        this.$bvModal.show('showModalTag');
      }).catch(() => {
        this.makeToast('Oopss', 'Erro ao buscar tags do produto!', 'danger')
      }).finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    addRegraPreco() {
      this.$bvModal.show('modalPriceRule');
    },
    dellPriceRule(i) {
      this.fields.selectedProducts[this.modalEditProductId].priceRule.splice(i, 1);      
    },
    dellPriceDiscountRule(i) {
      this.fields.selectedProducts[this.modalPriceDiscountId].priceDiscountRules.splice(i, 1);      
    },
    newRulePrice() {
      const item = {
        quantity: 0,
        price: '',
        exact_amount: false,
      }

      this.fields.selectedProducts[`${this.modalEditProductId}`].priceRule.push(item);
    },
    newRulePriceDiscount() {
      const item = {
        qtd: 0,
        discount: '',
        type: 1
      }

      this.fields.selectedProducts[`${this.modalPriceDiscountId}`].priceDiscountRules.push(item);
    },
    saveTags() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/savePaymentTags', this.tag)
      .then((response) => {
        if(response.data.error == false) {
          this.$bvModal.hide('showModalTag');

          this.makeToast('Sucesso', 'Tags salva com sucesso!', 'success')
        } else {
          this.makeToast('Oopss', 'Erro ao salvar tags do produto!', 'danger')
        }   
      }).catch(() => {
        this.makeToast('Oopss', 'Erro ao buscar tags do produto!', 'danger')
      }).finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    limparTags() {
      this.tag.id = null;
      this.tag.tags = '';
      this.tag.selected_product_id = null;
    },
    downloadQrCode(elementId, fileName){
      var qrCodeCanvas = document.getElementById(elementId).getElementsByTagName('canvas');
      var dataUrl = qrCodeCanvas[0].toDataURL();

      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };

      xhr.open('GET', dataUrl);
      xhr.send();
    },
    showPlanos() {

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosAppLojistaId', this.userTypeId())
      .then((response) => {
        this.planosApp = response.data.data;
        this.comissao = response.data.comissao;
        this.$store.dispatch('endLoader');
      })
    },
    openModalQrcode(id) {
      this.categoryProductId = id;
      this.getCategoryProduct();
      this.$bvModal.show('qrModal');
      this.searchLinks(id);
    },
    searchLinks(prodId) {

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/searchUrl', this.userTypeId())
        .then((response) => {
          this.url = `${response.data.domain}/product/${prodId}/details`
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao buscar link do produto!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
    editarProduto(productId) {
      this.limpaProduto();

      const data = {
        id:productId,
        lojistaId: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/dadosProdutoId', data)
        .then((res) => {

          Object.assign(this.dataProduct, {
            produto: res.data.produto, 
            id: res.data.id, 
            type: res.data.type,
            midiaProduct: res.data.midia,
            codbar: res.data.codbar,
            marca: res.data.marca,
            descricao: res.data.descricao,
            unidade: res.data.unidade,
            peso: res.data.peso,
            altura: res.data.altura,
            largura: res.data.largura,
            comprimento: res.data.comprimento,
            departamento_id: res.data.departamento_id,
            lojista_id: res.data.lojista_id,
            aprovar: res.data.aprovar,
            discontType: res.data.discontType,
            discontMoney: res.data.discontMoney,
            discontStart: res.data.discontStart,
            discontEnd: res.data.discontEnd,
            qtd_metros: res.data.qtd_metros,
            priceRule: res.data.priceRule,
            priceDiscountRules: res.data.priceDiscountRules,
            produto_fichas: res.data.produto_fichas,
            produto_fichas_remover: res.data.produto_fichas_remover,
            produto_fotos_remover: res.data.produto_fotos_remover,
            produto_fotos: res.data.produto_fotos,
            origem: res.data.origem,
            cad_status: res.data.cad_status
          });
          this.getVideo(productId);

          if (this.dataProduct.produto_fichas.length == 0 && this.userTypeId() == 4477) {
             this.dataProduct.produto_fichas.push(
              ...[
                { tipo: 'Marca', descricao: '' },
                { tipo: 'Linha', descricao: '' },
                { tipo: 'Modelo', descricao: '' },
                { tipo: 'Código', descricao: '' },
                { tipo: 'Compatibilidade', descricao: '' },
                { tipo: 'Material', descricao: '' },
                { tipo: 'Cor', descricao: '' }
              ]
            );
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.$bvModal.show('modalProduto');
        });
    },
    alterarProduto() {
      const valid = this.validarForm();
      if(valid == true) {
        this.makeToast('Oops!', 'Corrija os erros acima para cadastrar o produto!', 'danger');
        return;
      }

      this.dataProduct.path_video == undefined ? this.dataProduct.path_video = null : this.dataProduct.path_video;
      this.dataProduct.path_pdf == undefined ? this.dataProduct.path_pdf = null : this.dataProduct.path_pdf;

      const data = {
        lojista_id: this.userTypeId(),
        produto: this.dataProduct
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/alterarProdutoId', data)
        .then((response) => {
          if(response.data.error == false) {
            if(response.data.idNovo && response.data.idAntigo) {
              this.alterarProdutoHome(response.data.idNovo, response.data.idAntigo);
            } else {
              this.makeToast('Sucesso!', 'Produto atualizado com sucesso!', 'success');
              this.$bvModal.hide('modalProduto');
              this.table.records = [];
              this.get(true);
              this.dataProduct.path_video = null;
            }
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast('Oops!', 'Ocorreu um erro ao atualizar produto!', 'danger');
          }
        })
    },
    alterarProdutoHome(idNovo, idAntigo) {

      const data = {
        lojista_id: this.userTypeId(),
        idNovo: idNovo,
        idAntigo: idAntigo
      }

      this.$store.dispatch('shopkeeper/alterarHomeProduct', data)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso!', 'Produto atualizado com sucesso!', 'success');
            this.$bvModal.hide('modalProduto');
            this.table.records = [];
            this.get();
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast('Oops!', 'Ocorreu um erro ao atualizar produto!', 'danger');
          }
        });
    },
    formatUrl(foto) {
      return process.env.VUE_APP_FOTOS_URL+foto;
    },
    openModalFicha() {
      this.tipo = null;
      this.descricao = null;
      this.$bvModal.show('modalFicha');
    },
    addFicha() {
      this.dataProduct.produto_fichas.push({tipo: this.tipo, descricao: this.descricao});
      this.$bvModal.hide('modalFicha');
    },
    getVideo(productId) {
      const data = {
        'productId': productId, 
        'shopId': this.dadosUsuario.id
      }
      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/getVideoProduct', data)
      .then((res) => {
        if (!res) {
          return;          
        }

        this.path = res.data.path;
        this.dataProduct.type = res.data.type;
        this.dataProduct.midiaProduct = res.data;
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível obter a url, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },

    getYoutubeVideoUri,

    uploadImage() {
      const formData = new FormData();
      this.imageSelected = this.$refs.file.files[0];
      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileNewProduct', formData)
      .then((response) => {
        const file = response.data.data;
        this.dataProduct.produto_fotos.push({foto_png: file});
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível inserir a imagem, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    uploadPdf() {
      const formData = new FormData();
      const fileInput = document.getElementById('pdf');
      const filePdf = fileInput.files[0];
      formData.append('file', filePdf);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadPdfFileProduct', formData)
      .then((response) => {
        this.dataProduct.path_pdf = response.data.data;
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível inserir o pdf, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    removerFicha(i, item) { 
      if(!this.dataProduct.produto_fichas_remover) {
        this.dataProduct.produto_fichas_remover = [];
      }
      
      this.dataProduct.produto_fichas_remover.push(item);     
      this.dataProduct.produto_fichas = this.dataProduct.produto_fichas.filter((elemento, index) => index !== i);
    },
    removerFoto(i, item) {
      if(!this.dataProduct.produto_fotos_remover) {
        this.dataProduct.produto_fotos_remover = [];
      }

      this.dataProduct.produto_fotos_remover.push(item);
      this.dataProduct.produto_fotos = this.dataProduct.produto_fotos.filter((elemento, index) => index !== i);
    },
    menuPositionOne(isVisible) {
      this.menuVisibleOne = isVisible;
    },
    menuPositionTwo(isVisible) {
      this.menuVisibleTwo = isVisible;
    },
    selectType(type) {
      this.table.records = [];
      this.typeProducts = type;
      this.get();
    },
    linkFotos(origem) {
      if (origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      }

      return process.env.VUE_APP_FOTOS_URL;
    },
    openSelectedProductPricesEdit({
      selectedProductId,
      productName,
      productId,
    }) {
      this.$refs.setSelectedProductPrice.toggleOpen({
        selectedProductId,
        productName,
        productId,
      });
    },
    visibilityChanged(isVisible) {
      if (!isVisible || this.loading == true) return;
      if (this.pagination.lastPage >0 && this.pagination.currentPage >= this.pagination.lastPage) return;
      this.pagination.currentPage = this.pagination.currentPage + 1;
    },
    filterDate() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.pagination.lastPage = 1;

      this.get();
    },
    cleanSelection(inative = false) {
      this.fields.selectedProducts = {};
      this.filters = {};
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.pagination.lastPage = 1;
      this.inative = inative;

      this.filterDate();
    },
    produtosInativos() {
      this.cleanSelection(true);
    },
    pesquisar() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.pagination.lastPage = 1;

      this.get();
    },  
    get(isSave = false) {
      if (this.loading) return;

      this.buscaInativo = '';
      if (this.inative == true) {
        this.buscaInativo = 'inativo';
      }

      this.loading = true;
      this.$store.dispatch('startLoader');
      
      this.getSelectedProducts({
        userId: this.userTypeId(),
        productName: this.filters.name,
        codInt: this.filters.cod_int,
        currentPage: this.pagination.currentPage,
        familyId: this.filters.family,
        typeProducts: this.typeProducts,
        startDate: this.startDate,
        endDate: this.endDate,
        status: this.buscaInativo ? 'inativo' : '',
      })
        .then((response) => {
          const { perPage, total, lastPage } = response.data.data || {};
          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total;
          this.pagination.lastPage = lastPage;
          
          if(isSave) this.table.records = [];
          this.table.records.push(...response.data.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    newCategoryProduct() {
      if (
        this.idCategory == null ||
        this.idCategory == undefined ||
        this.idCategory == ''
      ) {
        this.makeToast(
          'Erro',
          'Selecione uma categoria para esse produto!',
          'danger'
        );
        return;
      }

      const data = {
        product_id: this.categoryProductId,
        home_menu_id: this.idCategory,
      };

      const items = this.categoryProductItems;
      const result = items.map((item) => {
        if (item.uuid == data.home_menu_id) {
          return true;
        } else {
          return false;
        }
      });

      if (result.includes(true)) {
        this.makeToast(
          'Erro',
          'Essa categorias já está cadastrada para esse produto!',
          'danger'
        );
        return;
      }

      this.$store.dispatch('startLoader');
      this.newMenuProductsCategory(data)
        .then(() => {
          this.idCategory = null;
          this.getCategoryProduct();
          this.$root.$emit('valid-available-app');
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao cadastrar a categoria ao produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getCategoryProduct() {
      this.$store.dispatch('startLoader');

      this.getMenuProductsApp(this.categoryProductId)
        .then((response) => {
          this.categoryProductItems = response.data.data;
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as categorias do produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    validCodInterno(id) {
      if (
        this.setCodInternoId == this.fields.selectedProducts[`${id}`].codInterno
      ) {
        return;
      }

      const data = {
        cod: this.fields.selectedProducts[`${id}`].codInterno,
        lojista_id: this.userTypeId(),
      };

      this.$store.dispatch('startLoader');
      this.validarCodInternoLojista(data)
        .then((response) => {
          if (response.data.data.cod == true) {
            this.fields.selectedProducts[`${id}`].codInterno =
              this.setCodInternoId;
            this.makeToast(
              'Oopss',
              'Esse código interno já está sendo usado!',
              'danger'
            );
          } else {
            this.makeToast('Sucesso', 'código interno disponível!', 'success');
          }
        })
        .finally(() => {
          this.setCodInternoId = null;
          this.$store.dispatch('endLoader');
        });
    },
    setdCodInterno(id) {
      this.setCodInternoId = this.fields.selectedProducts[`${id}`].codInterno;
    },
    getCategory() {
      this.$store.dispatch('startLoader');

      this.getMenusApp(this.userTypeId())
        .then((response) => {
          this.items = response.data.data;
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as categorias!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    formatMoneyUn(value) {
      if(value.match(/R/)){
        return value;
      } else {
        var money = parseFloat(value);
        return money.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL',});
      }
    },
    deleteMenu(id) {
      this.$store.dispatch('startLoader');

      this.deleMenuCategoryProduct(id)
        .then(() => {
          this.getCategoryProduct();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao excluir produto da categoria!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    openModalCategory(id) {
      this.categoryProductId = id;
      this.getCategoryProduct();
      this.$bvModal.show('selectCategory');
    },
    InativeProduct(productId) {
      this.$store.dispatch('startLoader');

      this.inativeSelectedProduct({ userId: this.userTypeId(), productId })
        .then(() => {
          this.makeToast('Sucesso', 'Produto desativado com sucesso!');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.table.records = [];
          this.pagination.currentPage = 1;
          this.get();
        });
    },
    ativarProduto(id) {
      this.$store.dispatch('startLoader');
      this.ativarProdutoLojista({ userId: this.userTypeId(), productId: id })
        .then((response) => {
          if (response.data.data.error == true) {
            this.makeToast('Oopss', 'Não possível ativar o produto!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Produto ativado!', 'success');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.table.records = [];
          this.pagination.currentPage = 1;
          this.pagination.lastPage = 1;
          this.get();
        });
    },
    mostrarAcoes(index, status) {
      this.$set(this.table.records[`${index}`], 'editing', status);
    },
    editPromotion() {
      this.$bvModal.show('modalEditPromotion');
    },
    saveProductMenuPromotion(id) {
      const data = {
        construp_user_id: this.userTypeId(),
        id: id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/saveProductMenuPromotion', data)
      .then((response) => {
        if(response.data.error == false) {
          this.makeToast('Sucesso', 'Produto salvo com sucesso!', 'success');

          const product = this.table.records.find((x) => x.id === id);
          if (product) {
            product.promotion = !product.promotion;
          }
        } else {
          this.makeToast('Oopss', 'Erro ao salvar produto!', 'danger');
        }   
      }).catch(() => {
        this.makeToast('Oopss', 'Erro ao salvar produto!', 'danger');
      }).finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    getMenuPromotion() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getMenuPromotion', this.userTypeId())
      .then((response) => {
        if (response.data) {
          this.promotion = response.data;
          this.promotion.status = response.data.status == 1 ? true : false;
        }
      }).catch(() => {
        this.makeToast('Oopss', 'Erro ao buscar menu promoção!', 'danger');
      }).finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    saveMenuPromotion() {
      this.promotion.construp_user_id = this.userTypeId();

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/saveMenuPromotion', this.promotion)
      .then((response) => {
        if(response.data.error == false) {
          this.$bvModal.hide('modalEditPromotion');
          this.makeToast('Sucesso', 'Menu promoção salvo com sucesso!', 'success');
        } else {
          this.makeToast('Oopss', 'Erro ao salvar menu promoção!', 'danger');
        }   
      }).catch(() => {
        this.makeToast('Oopss', 'Erro ao salvar menu promoção!', 'danger');
      }).finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    savePriceDiscountRule(product) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/savePriceDiscountRule', product)
      .then((response) => {
        if(response.data.error == false) {
          this.$bvModal.hide('modalDiscontRule');

          this.makeToast('Sucesso', 'Disconto(s) salvo com sucesso!', 'success');
          this.modalPriceDiscountId = null;
        } else {
          this.makeToast('Oopss', 'Erro ao salvar desconto(s) do produto!', 'danger');
        }   
      }).catch(() => {
        this.makeToast('Oopss', 'Erro ao salvar desconto(s) do produto!', 'danger');
      }).finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    editDiscountProduct(productId) {
      console.log()
      this.modalPriceDiscountId = productId;

      const product = this.table.records.find((x) => x.id === productId);

      const {
        priceSalesFormat1,
        priceSalesFormat2,
        quantityStock,
        quantityValid,
        codInterno,
        discont,
        withdrawalInOneDay,
        motorcycle,
        isExclusivePrice,
        isCaliper,
        discontType,
        discontMoney,
        discontStart,
        discontEnd,
        priceRule,
        priceDiscountRules,
        typeDelivery
      } = product;
    
      this.$set(this.fields.selectedProducts, `${productId}`, {
        productId,
        priceSalesFormat1: String(priceSalesFormat1),
        priceSalesFormat2: String(priceSalesFormat2),
        quantityStock,
        quantityValid,
        codInterno,
        discont,
        withdrawalInOneDay,
        motorcycle,
        isExclusivePrice,
        isCaliper,
        discontType,
        discontMoney,
        discontStart,
        discontEnd,
        priceRule,
        priceDiscountRules,
        typeDelivery
      });

      this.$bvModal.show('modalDiscontRule');
    },
    editProduct(productId) {
      this.modalEditProductId = productId;
      const product = this.table.records.find((x) => x.id === productId);

      const {
        priceSalesFormat1,
        priceSalesFormat2,
        quantityStock,
        quantityValid,
        codInterno,
        discont,
        withdrawalInOneDay,
        motorcycle,
        isExclusivePrice,
        isCaliper,
        discontType,
        discontMoney,
        discontStart,
        discontEnd,
        priceRule,
        priceDiscountRules,
        typeDelivery,
      } = product;
    
      this.$set(this.fields.selectedProducts, `${productId}`, {
        productId,
        priceSalesFormat1: String(priceSalesFormat1),
        priceSalesFormat2: String(priceSalesFormat2),
        quantityStock,
        quantityValid,
        codInterno,
        discont,
        withdrawalInOneDay,
        motorcycle,
        isExclusivePrice,
        isCaliper,
        discontType,
        discontMoney,
        discontStart,
        discontEnd,
        priceRule,
        priceDiscountRules,
        typeDelivery,
      });

      this.$bvModal.show('modalEditProduct');
    },
    /**
     * Remove o produto atual do estado de edição, removendo também os valores digitados
     * @param {Number | String} productId
     */
    cancelProductEdit(productId) {
      const index = this.getProductIndexFromTable(productId);

      this.$set(this.table.records[`${index}`], 'editing', false);

      delete this.fields.selectedProducts[`${productId}`];
    },
    trashSelectedProduct(productId) {

      const data = {
        produto_id: productId,
        lojista_id: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.trashSelectedProductId(data)
        .then((response) => {
          if(response.data.title) {
            const data = response.data;
            this.makeToast(`${data.title}`, `${data.message}`, `${data.type}`);

            if(data.type == 'success') {
              this.table.records = [];
              this.get();
            }
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    validCode(id) {
      this.setdCodInterno(id);
      this.validCodInterno(id);
    },

    editProductModal (event) {
      this.editSelectedProduct({
        productId: event.productId, 
        priceSalesFormat1: event.priceSalesFormat1,
        priceSalesFormat2: event.priceSalesFormat2,
        quantityStock: event.quantityStock,
        quantityValid: event.quantityValid,
        codInterno: event.codInterno,
        discont: event.discont,
        withdrawalInOneDay: event.withdrawalInOneDay,
        motorcycle: event.motorcycle,
        isExclusivePrice: event.isExclusivePrice,
        isCaliper: event.isCaliper,
        discontType: event.discontType,
        discontMoney: event.discontMoney,
        discontStart: event.discontStart,
        discontEnd: event.discontEnd,
        priceRule: event.priceRule,
        priceDiscountRules: event.priceDiscountRules,
        typeDelivery: event.typeDelivery

     });
    },

    editSelectedProduct({
      productId,
      priceSalesFormat1,
      priceSalesFormat2,
      quantityStock,
      quantityValid,
      codInterno,
      discont,
      withdrawalInOneDay = false,
      motorcycle = false,
      isExclusivePrice,
      isCaliper,
      discontType,
      discontMoney,
      discontStart,
      discontEnd,
      priceRule,
      priceDiscountRules,
      typeDelivery,
    }) {
      this.$store.dispatch('startLoader');

      priceSalesFormat1 = priceSalesFormat1 || '0.00';
      priceSalesFormat2 = priceSalesFormat2 || '0.00';

      this.updateSelectedProduct({
        userId: this.userTypeId(),
        product: {
          productId,
          priceSalesFormat1,
          priceSalesFormat2,
          quantityStock,
          quantityValid,
          codInterno,
          discont,
          withdrawalInOneDay: withdrawalInOneDay || false,
          motorcycle: motorcycle || false,
          isExclusivePrice: isExclusivePrice || false,
          isCaliper: isCaliper || false,
          discontType: discontType,
          discontMoney: discontMoney,
          discontStart: discontStart,
          discontEnd: discontEnd,
          priceRule: priceRule,
          priceDiscountRules: priceDiscountRules,
          typeDelivery: typeDelivery,
        },
      })
        .then(() => {
          this.makeToast('Sucesso', 'Produto editado com sucesso!');

          this.cancelProductEdit(productId);
          this.setEditedValuesToProductInTable(productId, {
            priceSalesFormat1,
            priceSalesFormat2,
            quantityStock,
            quantityValid,
            codInterno,
            discont,
            withdrawalInOneDay: withdrawalInOneDay || false,
            motorcycle: motorcycle || false,
            isExclusivePrice: isExclusivePrice || false,
            isCaliper: isCaliper || false,
            discontType: discontType,
            discontMoney: discontMoney,
            discontStart: discontStart,
            discontEnd: discontEnd,
            priceRule: priceRule,
            priceDiscountRules: priceDiscountRules,
            typeDelivery: typeDelivery,
          });

          this.modalEditProductId = null;

          this.$bvModal.hide('modalEditProduct');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    /**
     * Caso haja sucesso na atualização de um produto selecionado, para não precisarmos carregar
     * a tabela toda novamente, atualizamos diretamente o elemento na tabela
     */
    setEditedValuesToProductInTable(
      productId,
      {
        priceSalesFormat1,
        priceSalesFormat2,
        quantityStock,
        quantityValid,
        codInterno,
        discont,
        withdrawalInOneDay,
        motorcycle,
        isExclusivePrice,
        isCaliper,
        discontType,
        discontMoney,
        discontStart,
        discontEnd,
        priceRule,
        priceDiscountRules,
        typeDelivery,
      }
    ) {
      const index = this.getProductIndexFromTable(productId);
      this.$set(
        this.table.records[`${index}`],
        'priceSalesFormat1',
        convertBrlToDecimal(priceSalesFormat1).toFixed(2)
      );
      this.$set(
        this.table.records[`${index}`],
        'priceSalesFormat2',
        convertBrlToDecimal(priceSalesFormat2).toFixed(2)
      );
      this.$set(this.table.records[`${index}`], 'quantityStock', quantityStock);
      this.$set(this.table.records[`${index}`], 'quantityValid', quantityValid);
      this.$set(this.table.records[`${index}`], 'codInterno', codInterno);
      this.$set(this.table.records[`${index}`], 'discont', discont);
      this.$set(this.table.records[`${index}`], 'motorcycle', motorcycle);
      this.$set(this.table.records[`${index}`], 'isExclusivePrice', isExclusivePrice);
      this.$set(this.table.records[`${index}`], 'isCaliper', isCaliper);
      this.$set(this.table.records[`${index}`], 'discontType', discontType);
      this.$set(this.table.records[`${index}`], 'discontMoney', discontMoney);
      this.$set(this.table.records[`${index}`], 'discontStart', discontStart);
      this.$set(this.table.records[`${index}`], 'discontEnd', discontEnd);
      this.$set(this.table.records[`${index}`], 'priceRule', priceRule);
      this.$set(this.table.records[`${index}`], 'priceDiscountRules', priceDiscountRules);
      this.$set(this.table.records[`${index}`], 'typeDelivery', typeDelivery);
      this.$set(
        this.table.records[`${index}`],
        'withdrawalInOneDay',
        withdrawalInOneDay
      );
    },
    /**
     * @param {Number | String} productId
     * @returns {Number} The index
     */
    getProductIndexFromTable(productId) {
      if (!productId) return -1;

      const product = this.table.records.find((x) => x.id === productId);

      if (!product) return -1;

      return this.table.records.indexOf(product);
    },
    showModal(productId, product, typeProducts, selectedAt = '') {
      this.productModal = product;
      this.productSelectedAt = selectedAt;

      if (typeProducts == 'fixadores') {
        this.buscarDetalhesFixadores(productId);
      } else {
        this.buscarDetalhesGerais(productId);
      }
    },
    buscarDetalhesFixadores(productId) {
      this.$store.dispatch('startLoader');
      this.getDetalhesProdutoFixadores(productId)
        .then((response) => {
          this.detalhesP.fichas = response.data.ficha;
          this.detalhesP.fotos = response.data.fotos;
          this.detalhesP.produto = response.data.produto;
          this.$refs['detalhesProduto'].show();
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Erro ao buscar detalhes do produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    buscarDetalhesGerais(productId) {
      this.$store.dispatch('startLoader');

      const data = {
        productId: productId,
        lojistaId: this.userTypeId()
      }
      this.getDetalhesProdutoGeral(data)
        .then((response) => {
          console.log('Detalhes: ', response);
          this.detalhesP.fichas = response.data.ficha;
          this.detalhesP.fotos = response.data.fotos;
          this.detalhesP.produto = response.data.produto;
          console.log('Detalhes: ', this.detalhesP);
          this.$refs['detalhesProduto'].show();
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Erro ao buscar detalhes do produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    hideModal() {
      this.productModal = '';
      this.productSelectedAt = '';
      this.detalhesP.fichas = [];
      this.detalhesP.fotos = [];
      this.detalhesP.produto = null;
      this.$refs['detalhesProduto'].hide();
    },
    validItens(item) {
      if (item != null && item.status == 2) {
        return 'lineDanger';
      }
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.PRODUTO_SELECIONADO
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
    validarForm() {
      this.limpaErro();
      var valid = false;

      if(this.dataProduct.produto == null || this.dataProduct.produto == '') {
        this.error.produto = true;
        valid = true;
      }
      if(this.dataProduct.codbar == null || this.dataProduct.codbar == '') {
        this.error.codbar = true;
        valid = true;
      }
      if(this.dataProduct.marca == null || this.dataProduct.marca == '') {
        this.error.marca = true;
        valid = true;
      }
      if(this.dataProduct.unidade == null || this.dataProduct.unidade == '') {
        this.error.unidade = true;
        valid = true;
      }
      if(this.dataProduct.peso == null || this.dataProduct.peso == '0.00') {
        this.error.peso = true;
        valid = true;
      }
      if(this.dataProduct.altura == null || this.dataProduct.altura == '0.00') {
        this.error.altura = true;
        valid = true;
      }
      if(this.dataProduct.largura == null || this.dataProduct.largura == '0.00') {
        this.error.largura = true;
        valid = true;
      }
      if(this.dataProduct.comprimento == null || this.dataProduct.comprimento == '0.00') {
        this.error.comprimento = true;
        valid = true;
      }
      if(this.dataProduct.produto_fotos.length == 0) {
        this.error.fotos = true;
        valid = true;
      }

      return valid;
    },
    limpaProduto(){
      this.dataProduct.produto = null;
      this.dataProduct.codbar = null;
      this.dataProduct.marca = null;
      this.dataProduct.unidade = null;
      this.dataProduct.peso = null;
      this.dataProduct.altura = null;
      this.dataProduct.largura = null;
      this.dataProduct.comprimento = null;
      this.dataProduct.descricao = null;
      this.dataProduct.departamento_id = null;
      this.dataProduct.discontType = null;
      this.dataProduct.discontMoney = null;
      this.dataProduct.discontStart = null;
      this.dataProduct.discontEnd = null;
      this.dataProduct.priceRule = [];
      this.dataProduct.priceDiscountRules = [];
      this.dataProduct.lojista_id = null;
      this.dataProduct.qtd_metros = null;
      this.dataProduct.produto_fichas = [];
      this.dataProduct.produto_fotos = [];
      this.produto_fotos_remover = [];   
    },
    limpaErro(){
      this.error.produto = false;
      this.error.codbar = false;
      this.error.marca = false;
      this.error.unidade = false;
      this.error.peso = false;
      this.error.altura = false;
      this.error.largura = false;
      this.error.comprimento = false;
      this.error.departamento_id = false;
      this.error.produto_fichas = false;
      this.error.produto_fotos = false;        
    }
  },
};
</script>

<style scoped>
.danger {
  background: rgb(235, 24, 24);
  color: #fff;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}
.imgWidth {
  width: 50px;
  cursor: pointer;
}
.imgModal {
  max-width: 800px;
  max-height: 800px;
  width: auto;
  height: auto;
}
.btn-type-products {
  width: 50%;
  border: 1px solid #ff7f00;
  border-radius: 3px;
  padding: 5px 10px;
  color: #222;
  background-color: transparent;
}
.btn-type-products-selected {
  width: 50%;
  border: 1px solid #ff7f00;
  border-radius: 3px;
  padding: 5px 10px;
  color: #fff;
  background-color: #ff7f00;
}
.slideImg {
  display: flex;
  justify-content: center;
  align-items: center;
}
.scrollDiv {
  overflow: scroll;
  height: 300px;
}
.itensText {
  cursor: pointer;
  padding: 3px 15px;
  border-radius: 3px;
  margin-right: 5px;
}
.headTableFixed{
  background: rgb(255, 255, 255);
  z-index: 1;
  position: fixed;
  width:100vw;
  height: 60px;
  top: 49px;
  margin-left: -13px;
  text-align: start;
}
.headTable{
  background: white;
  border: none;
  padding: 0;
}
.dicontTable {
  background: green;
  color: #FFF;
  font-size: 12px;
  padding: 2px 5px;
  border-radius: 5px;
}
.checkEstoque {
  position: absolute;
  top: 0;
  left: 80px;
}

.archive-pdf {
  width: 100px;
  height: 100px;
}
</style>